/**
 * @param {string} matchId
 * @param {string} playerId
 * @return {string|null}
 */
export default (matchId, playerId) => (playerId ? `${playerId}@${matchId}` : null)
